import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getImportSearchValue = (state: IRootState) => state.import.searchValue;
export const getImportData = (state: IRootState) => state.import.data;
export const getImportOrder = (state: IRootState) => state.import.order;
export const getImportPage = (state: IRootState) => state.import.page;
export const getImportPageCount = (state: IRootState) => state.import.pageCount;
export const getImportTotalCount = (state: IRootState) => state.import.totalCount;
export const getImportCurrentUser = (state: IRootState) => state.import.isCurrentUser;
export const getImportFilters = (state: IRootState) => state.import.filters;
export const getImportTemplate = (state: IRootState) => state.import.template;
export const getImportKnoOrganizationId = (state: IRootState) => state.import.knoOrganizationId;
export const getImportKnoOrganizationErvkId = (state: IRootState) => state.import.knoOrganizationErvkId;
export const getImportSupervisionTypeErvkId = (state: IRootState) => state.import.supervisionTypeErvkId;
export const getImportKnmTypeId = (state: IRootState) => state.import.knmTypeId;
export const getImportSubjectTypeId = (state: IRootState) => state.import.subjectTypeId;
export const getImportSubjectTypeErvkId = (state: IRootState) => state.import.subjectTypeErvkId;
export const getImportPlanTypeFederalLawErvkId = (state: IRootState) => state.import.planTypeWithFederalLaw?.id;
export const getImportFederalLawErvkId = (state: IRootState) => state.import.federalLaw?.id;
